import React from "react";
import { categoryLabel, safeScreeningSource, screeningMessage } from "../utils/personScreening";
export default function ScreeningWarning({ screening, className = "pf-alert pf-alert--danger" }) {
  const result = screening.result;
  const warning = screeningMessage(result);
  if (!warning) return screening.pending ? <p className="screening-progress" role="status" style={{ margin: "12px 0", padding: "10px 12px", background: "#f1f5f9", color: "#475569", borderRadius: 8, fontSize: 14 }}>Checking names…</p> : null;
  return <div className={className} role="status" style={{ padding: "10px 12px", margin: "12px 0", whiteSpace: "pre-line", background: "#fff4d6", color: "#713f12", border: "1px solid #e5bc66", borderRadius: 8 }}>
    <div>⚠️ {warning}</div>
    {result?.matches?.slice(0, 5).map((match, index) => <div key={`${match.category}-${index}`} style={{ marginTop: 7 }}>
      <strong>{categoryLabel(match.category)}: {match.listedName}</strong>
      {match.role && <div>{match.role}{match.country ? ` — ${match.country}` : ""}</div>}
      {match.relationship && <div>{match.relationship}</div>}
      {match.reason && <div>{match.reason}</div>}
      {safeScreeningSource(match.sourceUrl) && <a href={match.sourceUrl} target="_blank" rel="noopener noreferrer">View source ↗</a>}
    </div>)}
  </div>;
}
